// ── the guides, in chapters (2026-09-29) ────────────────────────────────────
// Client-safe. The guides are read as a handful of CHAPTERS, never as a flat
// shelf: each chapter is one folder on /community/guides, and opening it opens
// a deck of its guides you swipe through, the one in front reading beneath.
//
// Every guide also carries its own HUE (frontmatter `hue`). That one number is
// the guide's whole identity: the ground of its thumbnail, the ground of every
// screenshot in it (scripts/guide-shots.mjs paints the real app in it before
// capturing), and the room its page stands in, with a netti of the matching
// colour. Walk a chapter and the colours walk with you; they are spread round
// the wheel so the whole set shows every colour innernet can be.

export interface Chapter {
  key: string;
  title: string;
  /** one line: what the chapter covers */
  description: string;
}

export const CHAPTERS: Chapter[] = [
  { key: "fundamentals", title: "the fundamentals", description: "what innernet is, your netti, your first memory, and how to ask it anything." },
  { key: "connect", title: "connecting your ai", description: "every ai tool on one memory over mcp: the one command, each tool by hand, what you already have, and the window in your chats." },
  { key: "dashboard", title: "the dashboard", description: "finding your way around, what innernet knows about you, the inbox, and keeping it yours." },
  { key: "builders", title: "for builders", description: "a repo with a memory of its own, and branches for trying an idea without losing the old one." },
  { key: "sharing", title: "sharing", description: "a page as a link, a memory with someone, and skills for the community." },
];

export const chapterOf = (key: string | undefined): Chapter | undefined => CHAPTERS.find((c) => c.key === key);

/** the pale ground a guide of this hue stands on (thumbnail, screenshots, page) */
export function guideGround(hue: number): string {
  return `hsl(${Math.round(((hue % 360) + 360) % 360)} 54% 88%)`;
}
/** the same ground as a hex, for the netti route's `?ground=` */
export function guideGroundHex(hue: number): string {
  const h = (((hue % 360) + 360) % 360) / 360, s = 0.54, l = 0.88;
  const k = (n: number) => (n + h * 12) % 12;
  const a = s * Math.min(l, 1 - l);
  const f = (n: number) => l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  return "#" + [f(0), f(8), f(4)].map((x) => Math.round(x * 255).toString(16).padStart(2, "0")).join("");
}
/** netti's hue for a guide: the house relation, 59° above its ground */
export function guideNettiHue(hue: number): number {
  return Math.round((((hue + 59) % 360) + 360) % 360);
}
